import React, { createContext } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useConfigurations } from './useConfigurations';

const useStyles = makeStyles(() => ({
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
}));

export const ConfigurationContext = createContext();

export const ConfigurationsProvider = ({ children }) => {
  const value = useConfigurations();
  const classes = useStyles();
  return (
    <ConfigurationContext.Provider value={value}>
      {value.configurations.loaded ? (
        children
      ) : (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      )}
    </ConfigurationContext.Provider>
  );
};
